import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as UserActions from "../../actions/userActions";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as constants from "../../constants";

const selectUserLogic = createLogic({
	type: ActionTypes.SELECT_USER,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.get(`/users/${action.userID}`)
					.then(data => {
						dispatch(UserActions.selectUserSuccess(data.data));
						done();
					})
					.catch(error => {
						dispatch(ControlPanelActions.displayError(error.message));
						done();
					});
			});
	},
});

export default [selectUserLogic];
